import AnalyzerPlaceholder from './AnalyzerPlaceholder';
import { AnalyzerPanelProps } from './DiscourseMarkersPanel';

/**
 * Mode d'anàlisi: semàntica (sinònims, definició, hiperònim).
 * En construcció. Interacció prevista: per paraula (clic sobre una paraula del
 * text → panell amb sinònims / definició / hiperònim). Farà la seva pròpia
 * crida amb `plainText` o amb la paraula seleccionada + `language`.
 */
export default function SemanticsPanel(_props: AnalyzerPanelProps) {
    // TODO: interacció per paraula → fetch('/v1/nlp/<semantics>', { word/text, language })
    return <AnalyzerPlaceholder title="Semantics" />;
}
